import api from './api';

export const adminAPI = {
  // Dashboard
  getDashboard: () => api.get('/admin/dashboard'),

  // User Management
  listUsers: (params = {}) => api.get('/admin/users', { params }),
  getUser: (id) => api.get(`/admin/users/${id}`),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  banUser: (id, reason) => api.post(`/admin/users/${id}/ban`, { reason }),
  unbanUser: (id) => api.post(`/admin/users/${id}/unban`),
  updateUserDP: (id, designPoints) => api.put(`/admin/users/${id}/design-points`, { design_points: designPoints }),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  togglePremium: (id, isPremium, duration = '1year') => api.post(`/admin/users/${id}/toggle-premium`, { is_premium: isPremium, duration }),
  getUserSubmissions: (id, params = {}) => api.get(`/admin/users/${id}/submissions`, { params }),
  resetUserProgress: (id) => api.post(`/admin/users/${id}/reset-progress`),

  // Challenge Management
  listChallenges: (params = {}) => api.get('/admin/challenges', { params }),
  getChallenge: (id) => api.get(`/admin/challenges/${id}`),
  createChallenge: (data) => api.post('/admin/challenges', data),
  updateChallenge: (id, data) => api.put(`/admin/challenges/${id}`, data),
  deleteChallenge: (id) => api.delete(`/admin/challenges/${id}`),

  // Component Management
  listComponents: (params = {}) => api.get('/admin/components', { params }),
  getComponent: (id) => api.get(`/admin/components/${id}`),
  createComponent: (data) => api.post('/admin/components', data),
  updateComponent: (id, data) => api.put(`/admin/components/${id}`, data),
  deleteComponent: (id) => api.delete(`/admin/components/${id}`),

  // Analytics
  getUserAnalytics: (period = '30d') => api.get('/admin/analytics/users', { params: { period } }),
  getChallengeAnalytics: () => api.get('/admin/analytics/challenges'),
  getActivityAnalytics: (period = '30d') => api.get('/admin/analytics/activity', { params: { period } }),

  // System Settings
  getSettings: () => api.get('/admin/settings'),
  updateSetting: (key, value) => api.put(`/admin/settings/${key}`, { value }),

  // Admin Whitelist
  getWhitelist: () => api.get('/admin/whitelist'),
  addToWhitelist: (email, notes = '') => api.post('/admin/whitelist', { email, notes }),
  removeFromWhitelist: (id) => api.delete(`/admin/whitelist/${id}`),

  // Activity Log
  getActivityLog: (params = {}) => api.get('/admin/activity-log', { params }),

  // Synergy Management
  listSynergies: (params = {}) => api.get('/admin/synergies', { params }),
  getSynergy: (id) => api.get(`/admin/synergies/${id}`),
  createSynergy: (data) => api.post('/admin/synergies', data),
  updateSynergy: (id, data) => api.put(`/admin/synergies/${id}`, data),
  deleteSynergy: (id) => api.delete(`/admin/synergies/${id}`),
  getComponentSynergies: (componentId) => api.get(`/admin/components/${componentId}/synergies`),

  // Policy Pages Management
  getPolicies: () => api.get('/admin/policies'),
  updatePolicy: (slug, data) => api.put(`/admin/policies/${slug}`, data),

  // Lead Magnet Management
  getLeadMagnetStatus: () => api.get('/admin/lead-magnet/status'),
  toggleLeadMagnet: (challengeId, isLeadMagnet) =>
    api.put(`/admin/challenges/${challengeId}/lead-magnet`, { is_lead_magnet: isLeadMagnet }),
  toggleFree: (challengeId, isFree) =>
    api.put(`/admin/challenges/${challengeId}/free`, { is_free: isFree }),
};

export default adminAPI;
